export const chatDrawerExpandedWidth = 360
export const FF_COPILOT_NARRATION = "ff_copilot_narration"

export const getStartedDemoInputs = {
    default: [
        { message: "Summarize this bill." },
        { message: "What questions were asked in this hearing, and by whom?" },
        { message: "Write a letter thanking the sponsor for introducing this bill." },
    ],
}
